module.exports = __webpack_public_path__ + "img/btw3.aa5484e0.jpg";